// @core/api/endpoints/userprofile/create_banner.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BannerResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Create a new banner
 * Uploads and creates a new banner image for a profile. Multiple banners can be stored, and one can be set as active.
 */
export async function CreateBanner(
  file: File,
  options?: RequestOptions
): Promise<BannerResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/banners`;
  const requestOptions = options;
  const formData = new FormData();
  formData.append('file', file);
  return client.post<BannerResponse>(requestPath, formData, requestOptions);
}
